export default "__VITE_ASSET__C5nAhe33__"